import React, {useState} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import ContactAvatar from "../../../../components-new/general/ContactAvatar";
import Translate from '../../../../components/Translate';
import {userLogoutRequest} from '../../../../services/user/action';
import config from "../../../../config";
import {logOperatorSession} from "../../../../services/user/api";
import SettingsIcon from "../../../../assets/icons/SettingsIcon";
import DropdownMenu from "../../../../components-new/ui/DropdownMenu";
import MenuItem from "../../../../components-new/ui/DropdownMenu/DropdownMenuItem"
import DropdownMenuSeparator from "../../../../components-new/ui/DropdownMenu/DropdownMenuSeparator"
import UserProfileModal from "./UserProfileModal";
import CompanySettingsModal from "./CompanySettingsModal";
import LogOutIcon from "../../../../assets/icons/LogOutIcon";
import LockKeyholeIcon from "../../../../assets/icons/LockKeyholeIcon";
import SecurityModal from "./SecurityModal";
import PersonIcon from "../../../../assets/icons/PersonIcon";

/*
 * One line, as the header sheet has it: the picture, the name, then the role
 * beside it rather than under it. The name used to sit in a 120px column with
 * the role stacked below in 9px grey, which made the tallest thing in the bar
 * out of the shortest piece of information in it.
 */
const triggerStyles = {
    row: {
        display: 'flex',
        gap: 'var(--ds-spacing-md)',
        alignItems: 'center',
        minWidth: 0,
    },
    name: {
        maxWidth: '140px',
        color: 'var(--ds-text-primary)',
        fontWeight: 'var(--ds-weight-semibold)',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
    role: {
        color: 'var(--ds-text-tertiary)',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
    },
};

const UserMenu = ({user, logoutUser, company}) => {

    const [activeModal, setActiveModal] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);

    const contact = {
        firstName: user.firstName,
        lastName: user.lastName,
        thumbUrl: user.thumbUrl,
    };

    const openModal = (modalName) => {
        setActiveModal(modalName);
        setIsModalOpen(true);
    };

    return (
        <React.Fragment>
            <DropdownMenu
                triggerContent={
                    <div style={triggerStyles.row}>
                        <ContactAvatar size={20} contact={contact} variant="menu"/>
                        <span style={triggerStyles.name}>
                            {user.firstName} {user.lastName}
                        </span>
                        <span style={triggerStyles.role}>{user.authorities[0].split('_')[1]}</span>
                    </div>
                }
                styles={{width: 'auto', height: '36px'}}
                classes="header-user-menu"
            >
                <MenuItem
                    id="header-profile-settings"
                    onClick={() => openModal('settingsModalIsOpen')}
                    icon={<PersonIcon width={16} height={16}/>}
                >
                    <Translate text="profile"/>
                </MenuItem>

                <MenuItem
                    id="header-security-settings"
                    onClick={() => openModal('securityModalIsOpen')}
                    icon={<LockKeyholeIcon width={16} height={16} stroke="currentColor"/>}
                >
                    <Translate text="security"/>
                </MenuItem>

                {user.authorities.includes(config.rolesMap.owner) &&
                    <MenuItem
                        id="header-company-settings"
                        onClick={() => openModal('companySettingsModalIsOpen')}
                        icon={<SettingsIcon width={16} height={16}/>}
                    >
                        <Translate text="company"/>
                    </MenuItem>
                }

                <DropdownMenuSeparator/>

                <MenuItem
                    id="header-logout"
                    onClick={async (event) => {
                        try {
                            await logOperatorSession({
                                operatorPlatformId: user.id,
                                parentCompanyId: user.companyId,
                                actionType: 'LOGOUT',
                                userAgent: navigator.userAgent,
                            });
                        } catch (e) {
                            console.error("Logging logout failed", e);
                        }
                        logoutUser();
                    }
                    }
                    danger
                    icon={<LogOutIcon stroke="currentColor" width={16} height={16}/>}
                >
                    <Translate text="logOut"/>
                </MenuItem>

            </DropdownMenu>

            {
                <UserProfileModal
                    onRequestClose={() => setIsModalOpen(false)}
                    close={() => setIsModalOpen(false)}
                    isOpen={activeModal === 'settingsModalIsOpen' && isModalOpen}/>
            }

            {
                <SecurityModal
                    onRequestClose={() => setIsModalOpen(false)}
                    close={() => setIsModalOpen(false)}
                    isOpen={activeModal === 'securityModalIsOpen' && isModalOpen}/>
            }

            {
                <CompanySettingsModal
                    company={company}
                    isOpen={activeModal === 'companySettingsModalIsOpen' && isModalOpen}
                    onRequestClose={() => setIsModalOpen(false)}
                />
            }
        </React.Fragment>
    )
}


UserMenu.propTypes = {
    user: PropTypes.object.isRequired,
    logoutUser: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
    logoutUser: () => {
        dispatch(userLogoutRequest());
    },
});

export default connect(null, mapDispatchToProps)(UserMenu);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/header/UserMenu.jsx